export default "__VITE_ASSET__CFknDrOp__"